class ProductSubscription extends HTMLElement {
  constructor() {
    super();

    this.onPlanChange = this.onPlanChange.bind(this);
  }

  connectedCallback() {
    this.priceTarget = this.closest('.product-information')?.querySelector('[data-product-local-prices]');
    this.priceElement = this.priceTarget?.querySelector('[data-product-local-price]');
    this.compareElement = this.priceTarget?.querySelector('[data-product-local-compare-price]');
    this.planInputs = Array.from(this.querySelectorAll('.product-subscription__input'));
    this.pricing = this.getPricingConfig();

    this.planInputs.forEach((input) => input.addEventListener('change', this.onPlanChange));

    if (this.pricing) {
      this.updateLocalPrice(this.getSelectedPlan() || this.pricing.defaultPlan || 'subscribe');
    }
  }

  disconnectedCallback() {
    this.planInputs.forEach((input) => input.removeEventListener('change', this.onPlanChange));
  }

  getPricingConfig() {
    const configElement = this.querySelector('[data-product-subscription-pricing]');
    if (!configElement) return null;

    try {
      return JSON.parse(configElement.textContent);
    } catch (error) {
      return null;
    }
  }

  getSelectedPlan() {
    return this.querySelector('.product-subscription__input:checked')?.value || null;
  }

  onPlanChange() {
    const plan = this.getSelectedPlan();
    if (!plan) return;

    this.updateLocalPrice(plan);
  }

  updateLocalPrice(plan) {
    if (!this.pricing || !this.priceElement) return;

    const isSubscribe = plan === 'subscribe';
    const activePricing = isSubscribe ? this.pricing.subscribe : this.pricing.onetime;

    this.priceElement.textContent = activePricing.totalFormatted;

    if (!this.compareElement) return;

    if (isSubscribe && this.pricing.discountPercent > 0) {
      this.compareElement.textContent = this.pricing.compareTotalFormatted;
      this.compareElement.hidden = false;
      return;
    }

    this.compareElement.textContent = '';
    this.compareElement.hidden = true;
  }
}

if (!customElements.get('product-subscription')) {
  customElements.define('product-subscription', ProductSubscription);
}
